import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'ui-components/button/button';
import imageSrc from 'shared/components/assets/Icons/mobile/mobile-registration.webp';
import fallbackSrc from 'shared/components/assets/Icons/mobile/mobile-registration.webp';
import googlePlay from 'shared/components/assets/Icons/mobile/google-play.webp';
import appStore from 'shared/components/assets/Icons/mobile/app-store.webp';
import { ImgWithFallback } from 'features/mobile-report/shared/components/img-with-fallback/img-with-fallback';
import { isMac } from 'features/mobile-report/utils/utils';
import { useAuthActions } from 'store/auth/use-auth-actions';
import type { UserData } from 'core/entities';
import { openAppLink } from 'features/authentication/utils/utils';
import { useRouteParam } from 'hooks/use-query/use-query';

import styles from './webview-registration-done.module.scss';

export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.placer.ai';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/placer-ai/id6448678251';

export const WebviewRegistrationDone = () => {
    const { state } = useLocation<{ user: UserData; next_url: string }>();
    const nextUrl = useRouteParam('next_url');

    const { loginMobile } = useAuthActions();

    const handleClick = () => {
        loginMobile(state?.user, state?.next_url || nextUrl);
    };

    return (
        <section className={styles.webviewRegistration}>
            <ImgWithFallback
                className={styles.image}
                src={imageSrc}
                fallbackSrc={fallbackSrc}
                alt="Account created"
            />
            <h2 className={styles.title}>Your account has been successfully created!</h2>
            <div className={styles.marketsButtons}>
                <Button
                    className={styles.appButton}
                    href={APP_STORE_URL}
                    type="ghost"
                    target="_blank"
                    rel="noreferrer"
                    disabled={!isMac}
                >
                    <img className={styles.marketButton} src={appStore} alt="App Store" />
                </Button>
                <Button
                    href={GOOGLE_PLAY_URL}
                    className={styles.appButton}
                    type="ghost"
                    target="_blank"
                    rel="noreferrer"
                    disabled={isMac}
                >
                    <img className={styles.marketButton} src={googlePlay} alt="Google Play" />
                </Button>
            </div>
            <div>
                <Button
                    type="link"
                    className={styles.loginButton}
                    href={openAppLink(state?.user, state?.next_url)}
                    onClick={handleClick}
                >
                    Log in via Web
                </Button>
            </div>
        </section>
    );
};
